import {Component,ElementRef, NgZone, ViewChild, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RoleService } from 'app/main/services/roles.service';
import { Usuario } from 'app/main/models/usuario.model';
import {TranslateService} from '@ngx-translate/core';

import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {map, startWith} from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {UsersService} from '../../../services/users.service';



@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class DialogBoxComponent {

  displayedColumnsEvaluaciones: string[] = ['nombre','estado','version','estructuraJerarquica','creador','dueno','fechaInicio','fechaFin'];

  action: string;
  LOCAL_DATA: any;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredTipos: Observable<any[]>;
  myControl = new FormControl();

  roles = [];
  displayedColumns: string[] = ['estructura','nombre'];

  constructor(
    private roleService: RoleService,
    private usuarioSer: UsersService,
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    public translate: TranslateService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Usuario) {
    console.log(data);
    this.LOCAL_DATA = {...data};
    this.action = this.LOCAL_DATA.action;
  }

  @ViewChild('usuarioInput') usuarioInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;


  doAction(): void{
    console.log('im here');
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {
    this.roleService.getAll().pipe().subscribe(req => {
      this.roles = req.body.map( tipo => {
        console.log(tipo);
        return {
          id: tipo.id,
          nombre: tipo.nombre
        };
      });

      this.filteredTipos = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value))
      );
    });
  }

  private _filter(value: String): any[] {
        const filterValue = value.toLowerCase() || '';
        return this.roles.filter(option => option.nombre.toLowerCase().includes(filterValue));
  }

  displayFn(value?: any) {
    return value ? this.roles.find(_ => _.id === value.id).nombre : (value!=null ? value.nombre: '');
  }


  selected(event: MatAutocompleteSelectedEvent): void {
    if(this.LOCAL_DATA.tipos == undefined){
      this.LOCAL_DATA.tipos = [];
    }

    const tiene = this.findTipo(event.option.value);

    if (!tiene) {
      this.LOCAL_DATA.tipos.push(event.option.value);
    }
    this.usuarioInput.nativeElement.value = '';
    this.myControl.setValue(null);
    this.usuarioInput.nativeElement.blur();
  }

  remove(tipo: any): void {
    const index = this.LOCAL_DATA.tipos.indexOf(tipo);

    if (index >= 0) {
      this.LOCAL_DATA.tipos.splice(index, 1);
    }
  }

  findTipo(tipo): boolean{
    var tiene = false;
    for(var i=0; i<this.LOCAL_DATA.tipos.length;i++){
      if(this.LOCAL_DATA.tipos[i].id == tipo.id){
        tiene = true;
        break;
      }
    }

    return tiene;
  }

  validarUsuarioPorCorreo(correo: string) {

    this.usuarioSer.findByCorreoElectronico(correo).pipe().subscribe(req => {
        if(req.body != null){
            if(this.LOCAL_DATA.id != req.body.id) {
                alert("El usuario con el correo electronico: " + correo + " ya existe");
            }
        }
    });
  }

  openDialog(): void {}

}
